import React from "react";

const SideColumnFlex = (props) => {
    return <div className={`flex flex-col ${props.className || ""}`}>{props.children}</div>;
};

export default SideColumnFlex;
